import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../Button'
import classes from '../Header/HeaderWrapper/HeaderWrapper.module.scss'

export const LanguageChange: React.FunctionComponent = () => {
  const { i18n } = useTranslation()
  const [de, setDe] = useState<boolean>()
  const [en, setEn] = useState<boolean>()
  const lang = ['DE', 'EN']
  const switchDE = () => {
    setDe(true)
    setEn(false)
    return i18n.changeLanguage('de')
  }

  const switchEN = () => {
    setDe(false)
    setEn(true)
    return i18n.changeLanguage('en')
  }

  useEffect(() => {
    if (i18n.language === 'de' || i18n.language === 'de-DE') {
      setDe(true)
      setEn(false)
    }
    if (i18n.language === 'en' || i18n.language === 'en-US') {
      setDe(false)
      setEn(true)
    }
  }, [i18n.language])
  return (
    <>
      <Button
        size="small"
        variant="tertiary"
        onClick={() => switchDE()}
        className={`${classes.button} wb-button-langauge ${de ? 'active' : ''}`}
      >
        {lang[0]}
      </Button>
      <Button
        size="small"
        variant="tertiary"
        onClick={() => switchEN()}
        className={`${classes.button} wb-button-langauge ${en ? 'active' : ''}`}
      >
        {lang[1]}
      </Button>
    </>
  )
}
